import React, { useState, useEffect, useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Question from '../question/Question';
import { makeStyles } from '@material-ui/core/styles';

//Script wird mit dem useEffect Hook geladen vergleichbar mit ComponentDidmound and Update
const loadScript = (url, callback) => {
  //check if script is already loaded
  let pscript = document.getElementById('mapsscriptreact');
  if (pscript == undefined) {
    let script = document.createElement('script');
    script.setAttribute('id', 'mapsscriptreact');
    script.type = 'text/javascript';
    script.onload = () => {
      console.log('Google Maps geladen');
      callback('Done');
    };
    script.onerror = function () {
      let elem = document.getElementById('mapsscriptreact');
      elem?.parentNode.removeChild(elem);
      alert('Konnte Google Maps nicht laden versuche es erneut '); // Error loading https://example.com/404.js
      setTimeout(() => {
        loadScript(url, callback);
      }, 500);
    };
    script.src = url;
    // Um Cors zu entgehen muss das ganze in den Header
    document.getElementsByTagName('head')[0].appendChild(script);
  } else {
    callback('Done');
  }
};

//AIzaSyBXRNuX_KXbaKkB1paBLYW_jCiueltvJkI

export default function Mapscard({
  daten,
  cardcontent,
  handleUpdate,
  url,
  hovercolor,
}) {
  const useStyles = makeStyles({
    ccsLabelFocused: {
      color: hovercolor + ' !important',
    },
    formLabelFocused: {
      color: hovercolor + ' !important',
    },
    cssFocused: {
      boxShadow: 'none',
      '& .MuiInput-input': {
        border: '1px ' + hovercolor + ' solid !important',
        borderBottom: '2px ' + hovercolor + ' solid !important',
        boxShadow: 'none',
      },
    },
    cssMaps: {
      boxShadow: 'none',
      '& .MuiInputBase-input': {
        border: '1px ' + hovercolor + ' solid !important',
        borderBottom: '2px ' + hovercolor + ' solid !important',
        boxShadow: 'none',
        marginTop: '0px',
      },
    },
    root: {
      '& .MuiOutlinedInput-notchedOutline': {
        border: '1px black solid !important',
        marginTop: '-5px',
      },

      boxShadow: 'none',
    },
    underline: {
      '&::after': {
        border: '1px solid ' + hovercolor + ' !important',
      },
    },

    option: {
      fontSize: 15,
      '& > span': {
        marginRight: 10,
        fontSize: 18,
      },
    },
    select: {
      '& ul': {
        backgroundColor: '',
      },
      '& li': {
        fontSize: '1rem',
      },
    },
    textField: {
      paddingBottom: 0,
      marginTop: 0,
      fontWeight: 10,
    },
  });

  const classes = useStyles();
  const [scriptloaded, setScript] = useState('');
  useEffect(() => {
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=AIzaSyDM0jxLDeA-Y2U0ONSrY06-cgs9wPbTQ5s&libraries=places`,
      setScript
    );
  }, []);
  let cardID =
    daten['chain'].length > 0
      ? daten['chain'][daten['chain'].length - 1].toString()
      : daten['chain'][0].toString();
  let step = daten['chain'].length;
  if ('adresse' in daten['info'][cardID] === false) {
    daten['info'][cardID]['adresse'] = {
      strasse: '',
      hausnummer: '',
      stadt: '',
      plz: '',
      land: '',
    };
    handleUpdate(daten);
  }
  if (daten['info'][cardID]['suche'] == undefined) {
    daten['info'][cardID]['suche'] = '';
  }

  if (daten['info'][cardID]['vorschlaege'] == undefined) {
    daten['info'][cardID]['vorschlaege'] = [];
  }
  const handleInputChange = (e, scriptloaded) => {
    if (e.target.value.length > 3 && scriptloaded == 'Done') {
      let sessionToken =
        new window.google.maps.places.AutocompleteSessionToken();
      let autoComplete = new window.google.maps.places.AutocompleteService();
      autoComplete
        .getPlacePredictions({
          input: e.target.value,
          sessionToken: sessionToken,
          componentRestrictions: { country: ['ch', 'de', 'at'] },
        })
        .then(function (response) {
          if ('predictions' in response) {
            daten['info'][cardID]['vorschlaege'] = [];
            response.predictions.forEach((entry, index) => {
              daten['info'][cardID]['vorschlaege'].push({
                label: entry.description,
                id: index,
                place_id: entry.place_id,
              });
            });
            handleUpdate(daten);
          }
        });
    } else {
      daten['info'][cardID]['vorschlaege'] = [];
      if (scriptloaded == undefined || scriptloaded == '') {
        setScript('Reload');
      }
    }
    daten['info'][cardID]['suche'] = e.target.value;
    handleUpdate(daten);
  };

  const handleChange = e => {
    cardID in daten['info'] ? 0 : (daten['info'][cardID] = {}); //Create Dict in Info if not exists
    'adresse' in daten['info'][cardID]
      ? 0
      : (daten['info'][cardID]['adresse'] = {
          strasse: '',
          hausnummer: '',
          stadt: '',
          plz: '',
          land: '',
        }); //Create Dict in Info if not exists

    'vorschlaege' in daten['info'][cardID]
      ? 0
      : (daten['info'][cardID]['vorschlaege'] = []); //Create Dict in Info if not exists

    daten['info'][cardID]['adresse'][e.target.id] = e.target.value;

    let mapsAdress =
      'https://www.google.com/maps/embed/v1/place?key=AIzaSyDM0jxLDeA-Y2U0ONSrY06-cgs9wPbTQ5s&q=' +
      daten['info'][cardID]['adresse']['strasse'] +
      '+' +
      daten['info'][cardID]['adresse']['hausnummer'] +
      '+' +
      daten['info'][cardID]['adresse']['plz'] +
      '+' +
      daten['info'][cardID]['adresse']['stadt'] +
      ',' +
      daten['info'][cardID]['adresse']['land'];

    daten['info'][cardID]['adresse']['mapsAdress'] = mapsAdress;

    if (
      daten['info'][cardID]['adresse']['strasse'] != '' &&
      daten['info'][cardID]['adresse']['hausnummer'] != '' &&
      daten['info'][cardID]['adresse']['plz'] != '' &&
      daten['info'][cardID]['adresse']['stadt'] != '' &&
      daten['info'][cardID]['adresse']['land'] != ''
    ) {
      daten['info'][cardID]['weiterButtonAllow'] = 1;
    } else {
      daten['info'][cardID]['weiterButtonAllow'] = 0;
    }

    handleUpdate(daten);
  };

  const handleSelect = (e, v, scriptloaded) => {
    if (scriptloaded == 'Done') {
      for (let i = 0; i < daten['info'][cardID]['vorschlaege'].length; i++) {
        if (
          daten['info'][cardID]['vorschlaege'][i].label ===
            e.target.textContent ||
          daten['info'][cardID]['vorschlaege'][i].label === v?.label
        ) {
          let map = new window.google.maps.Map(document.createElement('div'));
          let service = new window.google.maps.places.PlacesService(map);
          service.getDetails(
            {
              placeId: daten['info'][cardID]['vorschlaege'][i].place_id,
            },
            function (place, status) {
              if ('address_components' in place) {
                daten['info'][cardID]['adresse']['strasse'] = '';
                daten['info'][cardID]['adresse']['plz'] = '';
                daten['info'][cardID]['adresse']['land'] = '';
                daten['info'][cardID]['adresse']['stadt'] = '';
                for (let i = 0; i < place.address_components.length; i++) {
                  switch (place.address_components[i].types[0]) {
                    case 'route':
                      daten['info'][cardID]['adresse']['strasse'] =
                        place.address_components[i].long_name;
                      break;
                    case 'postal_code':
                      daten['info'][cardID]['adresse']['plz'] =
                        place.address_components[i].long_name;
                      break;
                    case 'locality':
                      daten['info'][cardID]['adresse']['stadt'] =
                        place.address_components[i].long_name;
                      break;

                    case 'country':
                      daten['info'][cardID]['adresse']['land'] =
                        place.address_components[i].long_name;
                      break;

                    default:
                      null;
                  }
                }
                daten['info'][cardID]['adresse']['show'] = true;
              }

              let mapsAdress =
                'https://www.google.com/maps/embed/v1/place?key=AIzaSyDM0jxLDeA-Y2U0ONSrY06-cgs9wPbTQ5s&q=' +
                daten['info'][cardID]['adresse']['strasse'];
              '+' +
                daten['info'][cardID]['adresse']['plz'] +
                '+' +
                daten['info'][cardID]['adresse']['stadt'] +
                ',' +
                daten['info'][cardID]['adresse']['land'];

              daten['info'][cardID]['adresse']['mapsAdress'] = mapsAdress;

              if (
                daten['info'][cardID]['adresse']['strasse'] != '' &&
                daten['info'][cardID]['adresse']['hausnummer'] != '' &&
                daten['info'][cardID]['adresse']['plz'] != '' &&
                daten['info'][cardID]['adresse']['stadt'] != '' &&
                daten['info'][cardID]['adresse']['land'] != ''
              ) {
                daten['info'][cardID]['weiterButtonAllow'] = 1;
              } else {
                daten['info'][cardID]['weiterButtonAllow'] = 0;
              }

              handleUpdate(daten);
              setTimeout(() => {
                document.getElementById('hausnummer').focus();
              }, 300);
            }
          );
        }
      }
    }
  };

  return (
    <div
      className=" flex flex-col justify-between place-items-center"
      id="mapscard"
    >
      <div className="text-center mt-40px">
        <Question questionNo={step} questionText={cardcontent['headline']} />
      </div>
      <Autocomplete
        id="mapsinputfieldx"
        className="w-260px md:w-400px"
        options={daten['info'][cardID]['vorschlaege']}
        isoptionequaltovalue={String((option, value) => option.id === value.id)}
        classes={{
          option: classes.option,
          paper: classes.select,
          focused: classes.cssMaps,
          root: classes.root,
        }}
        filterOptions={(options, state) => options}
        autoHighlight
        onChange={(e, v) => handleSelect(e, v, scriptloaded)}
        freeSolo={true}
        getOptionLabel={option => option.label}
        renderOption={option => <React.Fragment>{option.label}</React.Fragment>}
        renderInput={params => (
          <TextField
            {...params}
            InputLabelProps={{
              style: {
                color: 'black',
                fontSize: '1rem',
              },
              classes: {
                focused: classes.ccsLabelFocused,
              },
            }}
            id="mapsinputfieldxinner"
            label="Die Adresse Ihrer Immobilie?"
            onChange={e => handleInputChange(e, scriptloaded)}
            inputvalue={daten['info'][cardID]['suche']}
            variant="outlined"
            optionsselected={daten['info'][cardID]['suche']}
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password', // disable autocomplete and autofill
              style: {
                color: 'black',
                height: '50px',
              },
            }}
          />
        )}
      />
      <div></div>
      <div
        className={
          daten['info'][cardID]['adresse']['show']
            ? 'hidden'
            : 'flex flex-col mt-60px w-3/4 mb-40px '
        }
      >
        <span className="font-bold mr-5px">HINWEIS:</span>
        <div>
          Die Adresse Ihrer Immobilie ist sehr sensibel. Da sich die Preise je
          nach Lage auch innerhalb eines Ortes - stark unterscheiden können, ist
          diese Angabe elementar wichtig für eine aussagekräftige Bewertung.
        </div>
      </div>
      <div
        className={
          daten['info'][cardID]['adresse']['show']
            ? 'flex flex-col md:flex-row '
            : 'hidden'
        }
      >
        <div className="flex flex-col justify-center flex-wrap">
          <div className="flex flex-row justify-center mt-20px  flex-wrap">
            <TextField
              className="mx-2"
              InputProps={{
                style: {
                  width: '190px',
                  border:
                    daten['info'][cardID]['adresse']['strasse'].length == 0 &&
                    daten['info'][cardID]?.showerrors == 1
                      ? '1px solid red'
                      : '',
                },
                classes: {
                  focused: classes.cssFocused,
                  underline: classes.underline,
                },
              }}
              InputLabelProps={{
                classes: {
                  focused: classes.ccsLabelFocused,
                },
              }}
              id="strasse"
              label="Straße"
              value={daten['info'][cardID]['adresse']['strasse']}
              onChange={handleChange}
            ></TextField>
            <TextField
              className="mx-2"
              InputProps={{
                style: {
                  width: '190px',
                  border:
                    daten['info'][cardID]['adresse']['hausnummer'].length ==
                      0 && daten['info'][cardID]?.showerrors == 1
                      ? '1px solid red'
                      : '',
                },
                classes: {
                  focused: classes.cssFocused,
                  underline: classes.underline,
                },
              }}
              InputLabelProps={{
                classes: {
                  focused: classes.ccsLabelFocused,
                },
              }}
              id="hausnummer"
              label="Hausnummer"
              value={daten['info'][cardID]['adresse']['hausnummer']}
              onChange={handleChange}
            ></TextField>
          </div>
          <div className="flex flex-row justify-center mt-10px flex-wrap">
            <TextField
              className="mx-2"
              InputProps={{
                style: {
                  width: '190px',
                  border:
                    daten['info'][cardID]['adresse']['stadt'].length == 0 &&
                    daten['info'][cardID]?.showerrors == 1
                      ? '1px solid red'
                      : '',
                },
                classes: {
                  focused: classes.cssFocused,
                  underline: classes.underline,
                },
              }}
              InputLabelProps={{
                classes: {
                  focused: classes.ccsLabelFocused,
                },
              }}
              id="stadt"
              label="Stadt"
              value={daten['info'][cardID]['adresse']['stadt']}
              onChange={handleChange}
            ></TextField>
            <TextField
              className="mx-2"
              InputProps={{
                style: {
                  width: '190px',
                  border:
                    daten['info'][cardID]['adresse']['plz'].length == 0 &&
                    daten['info'][cardID]?.showerrors == 1
                      ? '1px solid red'
                      : '',
                },
                classes: {
                  focused: classes.cssFocused,
                  underline: classes.underline,
                },
              }}
              InputLabelProps={{
                classes: {
                  focused: classes.ccsLabelFocused,
                },
              }}
              id="plz"
              label="Postleitzahl"
              value={daten['info'][cardID]['adresse']['plz']}
              onChange={handleChange}
            ></TextField>
          </div>
          <div className="flex flex-row justify-center mt-10px">
            <TextField
              className="mx-2"
              InputProps={{
                style: {
                  width: '190px',
                  border:
                    daten['info'][cardID]['adresse']['land'].length == 0 &&
                    daten['info'][cardID]?.showerrors == 1
                      ? '1px solid red'
                      : '',
                },
                classes: {
                  focused: classes.cssFocused,
                  underline: classes.underline,
                },
              }}
              InputLabelProps={{
                classes: {
                  focused: classes.ccsLabelFocused,
                },
              }}
              id="land"
              label="Land"
              value={daten['info'][cardID]['adresse']['land']}
              onChange={handleChange}
            ></TextField>
          </div>
        </div>
        <div className="flex justify-center">
          <div className=" h-150px w-260px md:w-300px  ml-10px my-20px ">
            <iframe
              src={daten['info'][cardID]['adresse']['mapsAdress']}
              width="100%"
              height="100%"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}
